function r() {
  return [];
}
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/stubArray.js
// module id = 887
// module chunks = 41